// extracted by mini-css-extract-plugin
module.exports = {"sellPointsModule":"Fourth_sellPointsModule__FUwb0"};